import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliCheckbox } from '@lili/lili-frontend-common';
import { HomeAddressForm } from '@Pages/happyFlowPages/homeAddress/homeAddressForm/HomeAddressForm.tsx';
import { ControllerWrapper } from '@Hooks/index';
import { OnboardingFormFields } from '@Types/index.ts';

interface OwnerPersonalAddressFormProps {
  disabled: boolean;
  handleOnCheckChange: (isChecked: boolean) => void;
}
export const OwnerPersonalDetailsForm = ({
  disabled,
  handleOnCheckChange,
}: OwnerPersonalAddressFormProps) => {
  const { t } = useTranslation();
  return (
    <div className=' w-full'>
      <div className='flex flex-col md:flex-row align-baseline justify-start md:justify-between md:items-center'>
        <Heading.H9 fontWeight={FontWeight.SEMIBOLD} className='mb-[16px] text-text-main-secondary'>
          {t('pages.addOwner.personalAddressSection.title')}
        </Heading.H9>
        <div className='flex flex-row gap-[8px]'>
          <ControllerWrapper name={OnboardingFormFields.OWNER_SAME_AS_PRIMARY}>
            {({ value, onChange }) => (
              <LiliCheckbox
                id='sameAsMineCheckbox'
                checked={value}
                onCheckedChange={(val) => {
                  onChange(val);
                  handleOnCheckChange(val);
                }}
                containerClassName='w-[16px] h-[16px]'
              />
            )}
          </ControllerWrapper>
          <label htmlFor='sameAsMineCheckbox'>
            <Heading.H10
              fontWeight={FontWeight.REGULAR}
              className='mb-[16px] text-text-main-secondary'>
              {t('pages.addOwner.personalAddressSection.sameAddressCheckbox')}
            </Heading.H10>
          </label>
        </div>
      </div>

      <HomeAddressForm disabled={disabled} />
    </div>
  );
};
